module.exports = __webpack_public_path__ + "static/media/view hr dev. nd training.1795ad02.svg";